import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'

const Pagination = ({prevLink, prevTitle, nextLink, nextTitle, onNavigate}) => {
    const handleClick = (slug) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const url = `/blog_detail/${slug}`;
        window.history.pushState({}, '', url);
        if (onNavigate) onNavigate(slug);
    };

    return(
        <section className="w-[90%] mx-auto px-4 py-16">
            <div className="w-full flex flex-col md:flex-row justify-between items-center gap-6 mt-10">
                {prevLink ? (
                    <h3 className="font-['Libre_Caslon_Caption'] text-[24px] md:text-[32px] font-normal leading-[1.2] text-center">
                        <button
                            onClick={() => handleClick(prevLink)}
                            className="flex flex-row items-center text-[#1F0707aa] hover:text-[#D3752B] transition-colors duration-300"
                        >
                            <IoIosArrowBack className="mr-2 text-[28px]" />
                            {prevTitle}
                        </button>
                    </h3>
                ) : (
                    <div className="hidden md:block" />
                )}

                {nextLink && (
                    <h3 className="font-['Libre_Caslon_Caption'] text-[24px] md:text-[32px] font-normal leading-[1.2] text-center">
                        <button
                            onClick={() => handleClick(nextLink)}
                            className="flex flex-row items-center text-[#1F0707aa] hover:text-[#D3752B] transition-colors duration-300"
                        >
                            {nextTitle}
                            <IoIosArrowForward className="ml-2 text-[28px]" />
                        </button>
                    </h3>
                )}
            </div>
        </section>
    )
}

export default Pagination;